/* Dealer search, client side.

   Liquid cannot read ?postcode=, so the filtering that ran on the server in the
   prototype runs here instead. The URL stays the contract: it is read on load,
   written on submit with pushState, and re-read on popstate — so a result is
   still shareable and the back button still behaves.

   Cards are hidden with the `hidden` attribute; aw.css carries the
   `.aw [hidden] { display: none !important }` that makes it beat our own
   display rules, which the UA rule at specificity (0,0,0) cannot. */
(function () {
  'use strict';
  var root = document.querySelector('[data-aw-dsearch]');
  if (!root) return;

  var form = root.querySelector('[data-aw-dsearch-form]');
  var input = root.querySelector('[data-aw-dsearch-input]');
  var results = root.querySelector('[data-aw-dsearch-results]');
  var summary = root.querySelector('[data-aw-dsearch-summary]');
  var empty = root.querySelector('[data-aw-dsearch-empty]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.dcard'));
  var moreWrap = root.querySelector('[data-aw-dsearch-more-wrap]');
  var moreBtn = root.querySelector('[data-aw-dsearch-more]');

  /* How many to show for a postcode before "show all". Every dealer covers the
     whole country, so a postcode match is all 27 of them — a wall of cards that
     reads as "the search did nothing". The useful answer is the handful that
     are actually closest. */
  var NEAR = 5;

  /* The order the cards were rendered in. Sorting decides which cards match;
     it does not move them, because show() only toggles `hidden`. Without
     re-ordering the DOM the nearest dealer can appear third, which makes the
     "5 dichtstbijzijnde" heading look wrong. */
  var listEl = root.querySelector('[data-aw-dsearch-list]');
  var original = cards.slice();

  function order(list) {
    if (!listEl) return;
    var seen = [];
    list.forEach(function (c) { listEl.appendChild(c); seen.push(c); });
    original.forEach(function (c) { if (seen.indexOf(c) === -1) listEl.appendChild(c); });
  }

  /* Accepts "8112", "8112 BA", "8112BA". Anything else is treated as a place. */
  function parsePostcode(q) {
    var m = String(q).replace(/\s+/g, '').match(/^(\d{4})[a-zA-Z]{0,2}$/);
    return m ? parseInt(m[1], 10) : null;
  }

  function apply(q) {
    q = (q || '').trim();
    if (!q) {
      order(original);
      cards.forEach(function (c) { c.hidden = false; });
      results.hidden = true;
      empty.hidden = false;
      setMore(0);
      return;
    }

    var pc = parsePostcode(q);
    var inArea = [];
    var rest = [];

    if (pc !== null) {
      cards.forEach(function (c) {
        var from = parseInt(c.getAttribute('data-from'), 10);
        var to = parseInt(c.getAttribute('data-to'), 10);
        if (pc >= from && pc <= to) inArea.push(c);
      });

      /* Every AW dealer covers the whole country, so the band above matches all
         of them and on its own would return the full list in template order.
         Sorting by the distance between the visitor's postcode and the dealer's
         own is what makes the answer useful.

         Dutch postcodes run broadly south-east from 1000 in Amsterdam to 9999 in
         Groningen, so the numeric gap is a fair proxy for real distance — but
         only a proxy: 4000 Tiel and 4300 Zeeland are numerically close and 80km
         apart. Sorting by actual distance needs coordinates; PDOK Locatieserver
         (the Dutch government geocoder) is free and needs no API key. */
      inArea.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-postcode'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-postcode'), 10) || 0;
        return Math.abs(pa - pc) - Math.abs(pb - pc);
      });
      order(inArea);          /* nearest first, including the ones behind the button */
      rest = inArea.slice(NEAR);
      inArea = inArea.slice(0, NEAR);

      if (inArea.length === 0) {
        /* Nothing covers this postcode — show the three nearest bands rather
           than an empty result, which is the more useful answer and matches
           what the prototype did server-side. */
        var scored = cards.map(function (c) {
          var from = parseInt(c.getAttribute('data-from'), 10);
          var to = parseInt(c.getAttribute('data-to'), 10);
          return { c: c, gap: pc < from ? from - pc : pc - to };
        }).sort(function (a, b) { return a.gap - b.gap; }).slice(0, 3);
        var nearby = scored.map(function (x) { return x.c; });
        show(nearby);
        setMore(0);
        summary.innerHTML = 'Geen dealer met <strong>' + esc(q) +
          '</strong> in het eigen werkgebied' +
          (nearby.length ? ' — dit zijn de dichtstbijzijnde' : '');
        return;
      }
    } else {
      var needle = q.toLowerCase();
      cards.forEach(function (c) {
        if (c.getAttribute('data-city').indexOf(needle) !== -1 ||
            c.getAttribute('data-province').indexOf(needle) !== -1) inArea.push(c);
      });

      /* Only the 27 towns a dealer sits in, and the nine provinces, can match
         here. Someone in Zwolle or Breda matched nothing and was told "niets
         gevonden" — wrong twice over, because every dealer delivers there. An
         unknown place means we cannot sort by distance, not that nobody serves
         it, so show everyone and say so. */
      if (inArea.length === 0) {
        order(original);
        show(cards);
        setMore(0);
        summary.innerHTML = 'Geen dealer in <strong>' + esc(q) + '</strong> zelf. ' +
          'Al onze dealers leveren door heel Nederland — vul een postcode in om ze ' +
          'op afstand te sorteren.';
        return;
      }
    }

    show(inArea);
    setMore(rest.length);
    if (inArea.length && pc !== null) {
      /* "27 dealers gevonden" would be true and useless — they all cover the
         country, so the count never changes. What the visitor needs to know is
         that the list is ordered from nearest to furthest. */
      summary.innerHTML = 'De <strong>' + inArea.length + '</strong> dichtstbijzijnde ' +
        (inArea.length === 1 ? 'dealer' : 'dealers') + ' bij <strong>' + esc(q) +
        '</strong>. Al onze dealers leveren door heel Nederland.';
    } else if (inArea.length) {
      summary.innerHTML = '<strong>' + inArea.length + '</strong> ' +
        (inArea.length === 1 ? 'dealer' : 'dealers') + ' gevonden voor <strong>' + esc(q) + '</strong>';
    } else {
      summary.innerHTML = 'Niets gevonden voor <strong>' + esc(q) +
        '</strong>. Probeer een postcode of een plaatsnaam, of neem rechtstreeks contact met ons op.';
    }
  }

  /* `hidden` is what show() toggles, so revealing the rest is one pass. */
  function setMore(n) {
    if (!moreWrap || !moreBtn) return;
    moreWrap.hidden = n === 0;
    moreBtn.textContent = 'Toon alle ' + cards.length + ' dealers';
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      cards.forEach(function (c) { c.hidden = false; });
      moreWrap.hidden = true;
    });
  }

  function show(list) {
    cards.forEach(function (c) { c.hidden = list.indexOf(c) === -1; });
    results.hidden = false;
    empty.hidden = true;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function fromUrl() {
    var q = new URLSearchParams(window.location.search).get('postcode') || '';
    input.value = q;
    apply(q);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    var url = window.location.pathname + (q ? '?postcode=' + encodeURIComponent(q) : '');
    window.history.pushState({ q: q }, '', url);
    apply(q);
  });

  window.addEventListener('popstate', fromUrl);
  fromUrl();
})();
